<template>
  <div v-if="$withPolicy('dfe', 'crossing')">

    <div class="row mt-4">
      <div class="col-md-6">
        <input v-model="query.generic" class="input form-control"
               @keypress.enter="find()"
               placeholder="Pesquisar por: CNPJ ou Razão Social">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
    
      <div class="col-md-6">
        <button class="btn btn-outline px-3 mr-2"
                :class="{ 'btn-outline-active': showFilter }"
                @click="showFilter = !showFilter">
          Filtros
          <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
        </button>
      
        <button v-if="changeQuery" @click="find()" class="btn btn-link">
          Aplicar filtros ({{ numberOfBadges }})
        </button>
      </div>
    </div>
  
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :filters="[filterStartDate, filterEndDate, filterCompany, filterError]"
                      :query="query"
                      :amountChanged="updateNumberOfBadges"
                      @clearAllBadges="$nextTick(() => find())"
                      @clearBadge="$nextTick(() => find())"/>
      </div>
    </div>

    <div v-show="showFilter">

      <div class="row mt-4">

        <div class="col-md-3">
          <label for="fd-cnpjs">Estabelecimento</label>
          <Select2 id="fd-cnpjs" v-model="query.cnpj" :options="filterCompany"/>
        </div>

        <div class="col-md-3">
          <label for="crossing-error">Com erro no relatório</label>
          <select id="crossing-error" v-model="query.error" class="form-control">
            <option v-for="option in filterError.table" :value="option.value" :key="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="fd-start-date">Data inicial</label>
          <input v-model="query.startDate" type="month" class="form-control" id="fd-start-date">
        </div>

        <div class="col-md-3">
          <label for="fd-end-date">Data final</label>
          <input v-model="query.endDate" type="month" class="form-control" id="fd-end-date">
        </div>
      </div>

    </div>

    <hr>

    <div class="row mt-3">
      <div class="col-md-2">
        <button @click="showModalUpload=true" class="btn btn-primary">Upload de SPED</button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6 mt-2">
        <strong>{{ infoTotalModels }}</strong>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <table class="table table-borderless table-align">
          <thead>
            <tr>
              <th>Razão Social</th>
              <th>CNPJ</th>
              <th>NFe</th>
              <th>CTe</th>
              <th>Período</th>
              <th>Status do Cruzamento</th>
              <th>Atualizado em</th>
              <th>Reprocessar</th>
              <th>Downloads</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="crossing in crossings" :key="crossing.id">
              <td>{{ crossing.spedFiscal.companyName }}</td>
              <td>{{ crossing.spedFiscal.cnpj }}</td>
              <td>
                <p class="crossing-amount">SPED: <strong>{{ crossing.totalSpedNfe }}</strong></p>
                <p class="crossing-amount">
                  <a :href="buildLink(crossing, 'NFe')"
                     target="_blank"
                     title="Filtro para o mês deste SPED com NFes não escriturada"
                  >
                    DFe:
                  </a>
                  <strong>{{ crossing.totalDfeNfe }}</strong></p>
              </td>
              <td>
                <p class="crossing-amount">SPED: <strong>{{ crossing.totalSpedCte }}</strong></p>
                <p class="crossing-amount">
                  <a :href="buildLink(crossing, 'CTe')"
                     target="_blank"
                     title="Filtro para o mês deste SPED com CTes não escriturada"
                  >
                    DFe:
                  </a>
                  <strong>{{ crossing.totalDfeCte }}</strong></p>
              </td>
              <td>{{ formatDate(crossing.period) }}</td>
              <td>{{ crossing.status | t }}</td>
              <td>{{ crossing.updatedAt | datetime }}</td>
              <td class="text-center pl-0">
                <button v-if="crossing.status === 'processed'" @click="update(crossing)" class="btn btn-outline">
                  <PlayCircleIcon size="1.5x"/>
                </button>
              </td>
              <td>
                <div class="btn-group">
                  <button v-if="crossing.status === 'processed'" @click="download(crossing)" class="btn btn-outline nowrap">
                    <DownloadCloudIcon class="mr-2" size="1.5x"/>
                    <small><strong>Cruzamento</strong></small>
                  </button>
                  
                  <button @click="downloadSpedFiscal(crossing)" class="btn btn-outline nowrap">
                    <DownloadCloudIcon class="mr-2" size="1.5x"/>
                    <small><strong>SPED FISCAL</strong></small>
                  </button>
                  
                  <button v-if="crossing.error" @click="downloadErrorReport(crossing)" class="btn btn-outline">
                    <DownloadCloudIcon class="mr-2" size="1.5x"/>
                    <small><strong>Erros</strong></small>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>
    
    <Modal style="text-align: center;" v-model="showModalUpload" :with-footer="false">
      <h3 slot="header" class="my-2">Upload de Notas</h3>

      <div class="row">
        <div class="col-md-6 mx-auto">

          <h5 class="my-4">Você pode importar, individualmente ou em lote,<br> arquivos EFD ICMS IPI<br> leiautes oficiais, em extensão .txt ou<br> compactados em extensão .zip.</h5>
          <UploadArchive accept=".txt,.TXT,.zip"/>

        </div>
      </div>
    </Modal>

  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Formatter from '@/models/Formatter'
  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
	import Pagination from '@/components/shares/specialTag/Pagination'
  import Select2 from '@/components/shares/Select2'
  import UploadArchive from '@/components/shares/UploadArchive'
  import handleSearchable from '@/models/handleSearchable'
  
  import { Filter } from '@/models/filter'
  import { ChevronDownIcon, DownloadCloudIcon, PlayCircleIcon, SearchIcon } from 'vue-feather-icons'

  export default {
    components: { BadgeFilters, ChevronDownIcon, DownloadCloudIcon, Modal, Pagination, PlayCircleIcon, SearchIcon, Select2, UploadArchive },
    computed: {
      crossings() {
        return this.models
      }
    },
    created() {
      this.$set(this.query, 'error', '')
      this.defaultModelSetting.updateQueryURL = true
      this.includes.push('sped_fiscal')

      this.asyncTemplateSelect({
        byURL: true,
        finish: () => this.loadFilterCompany(),
        pagination: true
      })
    },
    data() {
      return {
        filterCompany: null,
        filterEndDate: new Filter({
          key: 'endDate',
          label: 'Data final',
          type: 'date'
        }),
        filterError: new Filter({
          key: 'error',
          label: 'Com erro',
          table: [
            ['Todos', ''],
            ['Sim', 'true'],
            ['Não', 'false'],
          ]
        }),
        filterStartDate: new Filter({
          key: 'startDate',
          label: 'Data inicial',
          type: 'date'
        }),
        modelPathPrefix: 'dfe',
        nameModel: 'Crossing',
        showModalUpload: false,
      }
    },
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        if (this.query.cnpj)
          this.query.cnpj = handleSearchable(this.query.cnpj)

        return ModelMapper.methods.buildParams.call(this, pagination)
      },
      buildLink(crossing, type) {
        const path = '/dfes'
        const spedFiscal = crossing.spedFiscal
        
        const queryString = [
          `q[start_date]=${spedFiscal.startDate}`,
          `q[end_date]=${spedFiscal.endDate}`.replace('00:00:00.000', '23:59:59.999'),
          `q[cnpj]=${spedFiscal.cnpj}`,
          `q[type]=${type}`,
          'q[bookkeeping]=false',
          'q[participant]=recipient'
        ].join('&')
  
        return `${path}?${queryString}`
      },
      download(crossing) {
        this.openLoad()
        this.axios.get(`dfe/crossings/${crossing.id}/download`, { responseType: 'blob' })
          .then(blob => this.$parse.buildDownload(`Cruzamento ${crossing.spedFiscal.cnpj} ${crossing.period}.csv`, blob))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
      downloadErrorReport(crossing) {
        this.openLoad()
        this.axios.get(`dfe/crossings/${crossing.id}/download_error_report`, { responseType: 'blob' })
          .then(blob => this.$parse.buildDownload(`Errors ${crossing.spedFiscal.cnpj} ${crossing.period}.csv`, blob))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
      downloadSpedFiscal(crossing) {
        this.openLoad()
        this.axios.get(`dfe/sped_fiscais/${crossing.dfeSpedFiscalId}/download`, { responseType: 'blob' })
          .then(blob => this.$parse.buildDownload(`SPED FISCAL ${crossing.spedFiscal.cnpj} ${crossing.period}.txt`, blob))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
      find() {
        this.asyncTemplateSelect()
      },
      formatDate(date) {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      },
      async loadFilterCompany() {
        const keyLocalStorage = 'lastFilterCompanyOfDFe'
        const label = 'Estabelecimento'
        const key = 'cnpj'
    
        let options = this.$ls.get(keyLocalStorage)
        if (options) {
          this.filterCompany = new Filter({ key, label, table: options })
          return
        }
    
        let response = await this.axios.get('companies', {
          params: {
            per_page: 1000,
            query: { type: ['parent', 'subsidiary'] }
          }
        })
    
        options = response.data.map(c => [
          `${c.name} - ${Formatter.cnpj(c.cnpj)}`, c.cnpj]
        )
    
        this.filterCompany = new Filter({key, label, table: options})
        this.$ls.set(keyLocalStorage, options, { minutes: 5 })
      },
      update(crossing) {
        this.asyncTemplateSave(crossing, {
          after: ({ model }) => {
            const index = this.crossings.findIndex(c => c.id === model.id)
            this.$set(this.crossings, index, model)
            this.$notify.add('Aguardando processamento.')
          }
        })
      }
    },
    mixins: [ModelMapper],
    name: 'Crossing'
  }
</script>

<style scoped>
  .crossing-amount {
    margin: 0;
    padding: 4px;
    white-space: nowrap;
  }
  
  .rotate-90 {
    transform: rotate(180deg);
  }

  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }
</style>
